import { render } from "./JumpLinkAdvance.vue?vue&type=template&id=0180690d&scoped=true"
import script from "./JumpLinkAdvance.vue?vue&type=script&lang=js"
export * from "./JumpLinkAdvance.vue?vue&type=script&lang=js"

import "./JumpLinkAdvance.vue?vue&type=style&index=0&id=0180690d&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0180690d"]])

export default __exports__